import { ButtonUnstyled, ResizeHandle, Text } from '@sketch/components'
import styled, { css } from 'styled-components'

import { ReactComponent as BellIconSvg } from '@sketch/icons/bell-24'

export const Wrapper = styled.div`
  display: flex;
  flex: 1;
  margin: 20px 0;
`

export const ListAndHeaderWrapper = styled.div`
  position: relative;
  overflow-x: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  padding: 0px 20px;

  border-right: 1px solid rgba(0, 0, 0, 0.05);
`

export const ListHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  position: sticky;
  top: 0;
  padding: 5px 0 5px;
  min-height: 42px;
`

export const ListHeaderText = styled(Text).attrs({
  textStyle: 'header.primary.H',
})`
  margin-left: 16px;
  margin-right: auto;
`

export const HeaderActions = styled.div<{ $hidden?: boolean }>(
  ({ $hidden }) => css`
    display: flex;
    align-items: center;
    gap: 4px;
    margin-left: auto;
    line-height: 0;

    ${$hidden &&
    css`
      visibility: hidden;
      pointer-events: none;
      width: 0;
      margin-right: 20px;
    `}
  `
)

export const InboxHeaderButton = styled(ButtonUnstyled)<{
  $isActive?: boolean
}>(
  ({ theme, $isActive }) => css`
    cursor: pointer;
    width: 40px;
    height: 32px;

    padding: 4px 8px;
    border-radius: ${theme.radii.large};

    background-color: ${$isActive ? theme.colors.sketch.F : undefined};

    svg {
      color: ${$isActive
        ? theme.colors.sketch.A
        : theme.colors.foreground.secondary.D};
    }

    &:hover {
      background-color: ${$isActive
        ? theme.colors.sketch.F
        : theme.colors.state.hover};

      svg {
        color: ${$isActive
          ? theme.colors.sketch.A
          : theme.colors.foreground.secondary.A};
      }
    }
  `
)

export const ListWrapper = styled.ul`
  padding: 0;
  margin: 0;
  flex: 1;
`

export const ListHeader = styled.li`
  padding: 20px 16px 12px;
  list-style: none;

  font-size: ${({ theme }) => theme.fontSizes.D};
  font-weight: 500;
`

export const UpdatePreview = styled.div`
  flex: 1;
  display: flex;
  padding: 20px;
`

export const EmptyPreview = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 22px;
`

export const EmptyPreviewIcon = styled(BellIconSvg)`
  width: 96px;
  height: 96px;
  color: ${({ theme }) => theme.colors.foreground.secondary.A};
`

export const EmptyPreviewText = styled(Text).attrs({
  textStyle: 'copy.primary.standard.F',
})`
  margin: 0;
  font-weight: 500;
`

export const InboxResizeHandle = styled(ResizeHandle)`
  right: 0;
  width: 6px;

  ::before {
    bottom: 0;
    margin: auto;
    height: 40px;
  }
`
